import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StaticPathUtil } from '@app/core/util/static-path.util';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { TextSmallDirective } from '../../../core/directive/text-small.directive';

@Component({
  selector:        'app-person-container',
  templateUrl:     './person-container.component.html',
  styleUrls:       ['./person-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone:      true,
  imports:         [
    NgIf,
    NgClass,
    NgStyle,
    TextSmallDirective,
    NgFor
  ]
})
export class PersonContainerComponent  {

  @Input()
  imageURL: string;

  @Input()
  fallbackURL = this.staticPath.getFallbackPath();

  @Input()
  vorname: string;

  @Input()
  name: string;

  @Input()
  subText: string[];

  @Input()
  mail: string;

  @Input()
  mailContent: string;

  @Input()
  fest: string;

  @Input()
  mobil: string;

  @Input()
  fax: string;

  @Input()
  enableEnlargeImage = true;

  @Input()
  titelPre: string;

  @Input()
  titelPost: string;

  @Input()
  abteilung: string;

  constructor(private staticPath: StaticPathUtil) { }



  public enlargePic(): void {
    if (this.enableEnlargeImage) {
      window.open(this.imageURL, '_blank');
    }
  }

}
